<div class="container-fluid auto-height-wrapper px-3">
  <div class="row g-4 dashboard">

    <!-- Card 1: Resumen de Tareas Pendientes -->
    <div class="col-12 col-md-6">
      <div class="card card-custom card-stretch h-100">
        <div class="card-header border-0 pt-4">
          <h3 class="card-title fw-bold">Resumen de Tareas Pendientes</h3>
          <h6 class="card-subtitle">{{ countask }} Tareas Pendientes</h6>
        </div>
        <div class="google-chart-wrapper p-3">
          <google-chart
            *ngIf="chartgoogletask?.data?.length > 0"
            [type]="chartgoogletask.type"
            [data]="chartgoogletask.data"
            [columns]="chartgoogletask.columnNames"
            [options]="chartgoogletask.options">
          </google-chart>
        </div>
      </div>
    </div>

    <!-- Card 2: Estado Tareas -->
    <div class="col-12 col-md-6 col-xl-6">
      <div class="card card-custom card-stretch h-100">
        <div class="card-header border-0 pt-4">
          <h3 class="card-title fw-bold">Estado Tareas</h3>
        </div>
        <div class="google-chart-wrapper p-3">
          <google-chart
            *ngIf="statusTaskG?.data?.length > 0"
            [type]="statusTaskG.type"
            [data]="statusTaskG.data"
            [columns]="statusTaskG.columnNames"
            [options]="statusTaskG.options"
            [width]="statusTaskG.width"
            [height]="statusTaskG.height">
          </google-chart>
        </div>
        <ng-template #noData>
          <p class="p-3">No hay datos disponibles para graficar.</p>
        </ng-template>
      </div>
    </div>

    <!-- Cards dinámicas -->
    <ng-container *ngFor="let item of chartgoogle">
      <div class="col-12 col-md-6 col-xl-4">
        <div class="card card-custom card-stretch h-100">
          <div class="card-header border-0 pt-4">
            <h3 class="card-title fw-bold">{{ item.title }}</h3>
          </div>
          <div class="google-chart-wrapper p-3">
            <google-chart
              [type]="item.type"
              [data]="item.data"
              [columns]="item.columnNames"
              [options]="options">
            </google-chart>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Área para widgets futuros -->
    <div class="col-12">
      <div class="row">
        <div class="col-lg-4"><!-- Widget adicional 1 --></div>
        <div class="col-lg-8"><!-- Widget adicional 2 --></div>
      </div>
    </div>

  </div>
</div>
